import { createContext, type Dispatch, type SetStateAction } from "react"
import type { User } from "firebase/auth"
import type { Advisor } from "@/features/advisors"

import type { ChatPlan } from "../config/plans"
import type {
  AssistantStatusResponse,
  ChatMessages,
  ChatsMessage,
  PalmReadingData,
  Thread,
  UnreadAdvisor,
} from "../types"

export interface ChatContextValue {
  unreadAdvisorIds: string[]
  setUnreadAdvisorIds: Dispatch<SetStateAction<string[]>>
  unreadAdvisors: UnreadAdvisor[]
  setUnreadAdvisors: Dispatch<SetStateAction<UnreadAdvisor[]>>
  selectedAdvisor: Advisor | null
  setSelectedAdvisor: (v: Advisor | null) => void
  sendMessage: (v: string) => void
  chatsMessages: ChatsMessage[]
  messages: ChatMessages
  setMessages: Dispatch<SetStateAction<ChatMessages>>
  assistantStatuses: AssistantStatusResponse[]
  liveChatPlans: ChatPlan[]
  userMainSubscriptionId: string | null
  updateThreads: () => void
  userCreditsCount: number | null
  emitEnterChatEvent: () => void
  emitLeaveChatEvent: () => void
  preSelectedChatMessage: string | null
  setPreSelectedChatMessage: (v: string | null) => void
  isPalmReadingLocked: boolean
  setIsPalmReadingLocked: (v: boolean) => void
  palmReadingData: PalmReadingData
  setPalmReadingData: (v: PalmReadingData) => void
  user: User | null
  currentThreadId: string | null
  palmReportModalOpen: boolean
  setPalmReportModalOpen: (v: boolean) => void
  chatWithAdvisorModalOpen: boolean
  setChatWithAdvisorModalOpen: (v: boolean) => void
  threads: Thread[]
  /**
   * Local last-activity (unix seconds) per assistant. Bumped on send / inbound
   * reply so the Readings list can re-sort without waiting for `my_threads`.
   */
  activityAtByAssistant: Record<string, number>
  freeMinutesLeft: number | null
  /** Local: user completed at least one stars top-up on this device. */
  hasPurchasedCredits: boolean
  markCreditsPurchased: () => void
  userUsedCredits: number | null
}

export const ChatContext = createContext<ChatContextValue | null>(null)
